export const memberProfile = {
  "verified": "Geverifieerd",
  "online": "Verbonden",
  "memberSince": "Lid sinds",
  "contact": "Contact opnemen",
  "share": "Delen",
  "respondsIn": "Reageert binnen",
  "responseRate": "reactie",
  "exchangesCompleted": "Gerealiseerde ruilen",
  "reviews": "beoordelingen",
  "responseRateLabel": "Reactiepercentage",
  "memberSinceLabel": "Lid sinds",
  "years": "jaar",
  "year": "jaar",
  "exchangeHistory": "Ruilhistorie",
  "property": "Woning",
  "reviewsTab": "Beoordelingen",
  "all": "Alle",
  "completed": "Voltooid",
  "upcoming": "Toekomstig",
  "cancelled": "Geannuleerd",
  "exchangeWith": "Ruil met",
  "nights": "nachten",
  "noExchangeInCategory": "Geen ruil in deze categorie",
  "offeredProperty": "Aangeboden woning",
  "memberReviews": "Beoordelingen van leden"
};
